import axios from "axios";
import React, { useState } from "react";
import ProductCard from "../Cards/ProductCard";
import style from "./DeleteProduct.module.css";
import Button from "@material-ui/core/Button";
import photo2 from "../../assets/card1.png";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";

import CheckIcon from "@material-ui/icons/Check";

export const DeleteProduct = () => {
  const [conf, setConf] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [showVela, setShowVela] = useState({
    codigo: "",
    producto: "",
    foto: "",
    peso: "",
    altura: "",
    diametrosup: "",
    diametroinf: "",
    duracion: "",
    ancho: "",
    largo: "",
  });

  const validate = () => {
    setConf(true);
  };

  const closevalidate = () => {
    setConf(false);
  };

  const useStyles = makeStyles((theme) => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setOpen2(false);
  };

  let handler = (e) => {
    setCodigo(e.target.value);
  };

  let buscar = async () => {
    let vela = await axios.get(
      `https://iluminarte3.herokuapp.com/admin/${codigo}`
    );

    if (vela.data.length > 0) {
      setShowVela({
        codigo: vela?.data[0]?.codigo,
        producto: vela?.data[0]?.producto,
        foto: vela?.data[0]?.foto,
        peso: vela?.data[0]?.peso,
        altura: vela?.data[0]?.altura,
        diametrosup: vela?.data[0]?.diametrosup,
        diametroinf: vela?.data[0]?.diametroinf,
        duracion: vela?.data[0]?.duracion,
        ancho: vela?.data[0]?.ancho,
        largo: vela?.data[0]?.largo,
      });
    } else setOpen2(true);
  };

  let deleteProduct = () => {
    axios
      .delete(
        `https://iluminarte3.herokuapp.com/admin/delete/${showVela.codigo}`
      )
      .then((response) => {
        if (response.status === 200) setOpen(true), closevalidate();
        else if (response.status === 500) setOpen2(true);
      })
      .catch((error) => setOpen2(true));
  };

  const veladisplay = {
    img: photo2,
    title: showVela.producto,
    sizes: showVela.altura,
    colors: showVela.producto,
    smell: showVela.duracion,
    code: showVela.codigo,
  };

  return (
    <div>
      <label for="codigo">Busca producto por codigo:</label>
      <input
        onChange={handler}
        id="codigo"
        name="codigo"
        type="text"
        className={style.input}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={buscar}
        className={style.btn}
      >
        Buscar por codigo
      </Button>

      <div className={style.deleteCont}>
        <div className={style.cardCont}>
          {" "}
          <ProductCard info={veladisplay}></ProductCard>
        </div>
        <div className={style.btnCont}>
          <Button
            className={style.btn}
            variant="contained"
            color="primary"
            onClick={validate}
          >
            Eliminar Producto
          </Button>

          {!conf ? (
            ""
          ) : (
            <div className={style.confirm}>
              <Button
                onClick={deleteProduct}
                variant="contained"
                color="primary"
                className={style.check}
              >
                <CheckIcon></CheckIcon>
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={style.cross}
                onClick={closevalidate}
              >
                <ClearIcon></ClearIcon>
              </Button>
            </div>
          )}
        </div>
      </div>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Producto eliminado</h2>
              <p id="transition-modal-description">Todo ha salido bien!</p>
            </div>
          </Fade>
        </Modal>
      </div>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open2}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open2}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">El producto no existe</h2>
              <p id="transition-modal-description">
                Escribe bien el codigo o crea un producto nuevo!
              </p>
            </div>
          </Fade>
        </Modal>
      </div>
    </div>
  );
};
